(() => {
  const bind = (slideshow) => {
    const scroller = slideshow.querySelector('slideshow-slides');
    const track = slideshow.querySelector('.carousel-progress__track');
    const thumb = track?.querySelector('.carousel-progress__thumb');
    if (!scroller || !track || !thumb || track.dataset.bound) return;
    track.dataset.bound = '1';

    let dragging = false;

    const metrics = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      const ratio = scroller.scrollWidth > 0 ? scroller.clientWidth / scroller.scrollWidth : 1;
      const thumbPct = Math.min(100, Math.max(12, ratio * 100));
      const progress = max > 0 ? scroller.scrollLeft / max : 0;
      return { max, thumbPct, progress };
    };

    const paint = () => {
      const { thumbPct, progress } = metrics();
      thumb.style.width = `${thumbPct}%`;
      thumb.style.transform = `translateX(${progress * ((100 - thumbPct) / thumbPct) * 100}%)`;
      thumb.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
    };

    const setFromClientX = (clientX) => {
      const { max, thumbPct } = metrics();
      if (max <= 0) return;
      const rect = track.getBoundingClientRect();
      const thumbPx = (thumbPct / 100) * rect.width;
      const usable = Math.max(1, rect.width - thumbPx);
      const x = Math.min(usable, Math.max(0, clientX - rect.left - thumbPx / 2));
      scroller.scrollLeft = (x / usable) * max;
      paint();
    };

    scroller.addEventListener(
      'scroll',
      () => {
        if (!dragging) paint();
      },
      { passive: true }
    );
    new ResizeObserver(paint).observe(scroller);

    const startDrag = (event) => {
      dragging = true;
      track.setPointerCapture(event.pointerId);
      setFromClientX(event.clientX);
      event.preventDefault();
    };

    const moveDrag = (event) => {
      if (!dragging) return;
      setFromClientX(event.clientX);
    };

    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      if (track.hasPointerCapture?.(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }
    };

    track.addEventListener('pointerdown', startDrag);
    track.addEventListener('pointermove', moveDrag);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    thumb.addEventListener('keydown', (event) => {
      const { max } = metrics();
      if (max <= 0) return;
      const step = max * 0.1;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        scroller.scrollLeft = Math.min(max, scroller.scrollLeft + step);
        event.preventDefault();
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        scroller.scrollLeft = Math.max(0, scroller.scrollLeft - step);
        event.preventDefault();
      } else if (event.key === 'Home') {
        scroller.scrollLeft = 0;
        event.preventDefault();
      } else if (event.key === 'End') {
        scroller.scrollLeft = max;
        event.preventDefault();
      }
    });

    paint();
  };

  const init = () => {
    document.querySelectorAll('slideshow-component.carousel-content').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
